import { useOrderContext } from '../../../../../providers/OrderProvider';
import OrderRewardSummary from './OrderRewardSummary';

const OrderRewardSection = () => {
	const { order } = useOrderContext();

	if (!order?.uiHints?.canShowOrderRewardSummary) {
		return <p className='fs-10 text-muted mb-4'>完成后展示奖励合算</p>;
	}

	return <OrderRewardSummary />;
};

export default OrderRewardSection;
